import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ResolverService } from "src/app/core";
import { ReportsFacadeService } from "../../services/reports-facade.service";
import { Profile } from "src/app/core/models/initials.model";
import { SharedCustomersService } from "src/app/shared/services/customers/customers.service";
import { CustomersResults } from "src/app/shared/models/customers.model";
import { SnackBarService } from "src/app/shared/services/snackbar/snackbar";
import { CascadeInvoiceItemsReport } from "../../models/cascade-invoice-items-report.model";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-sales-print",
  templateUrl: "./sales-print.component.html",
  styleUrls: ["./sales-print.component.scss"],
})
export class SalesPrintComponent implements OnInit {
  printFilters: any;
  sellerProfile: Profile;
  buyerProfile: CustomersResults;
  itemList: CascadeInvoiceItemsReport[];
  environmentConfig = environment;
  titles: string[] = [
    "No.",
    "Activity",
    "Description",
    "QTY",
    "Rate",
    "Amount",
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    private resolverSerivce: ResolverService,
    private reportsService: ReportsFacadeService,
    private sharedCustomersService: SharedCustomersService,
    private snackbarService: SnackBarService
  ) {}

  ngOnInit(): void {
    this.getUrlData();
  }

  getUrlData() {
    this.activatedRoute.params.subscribe((params) => {
      this.printFilters = params;
      this.getSellerProfile();
      if (!this.printFilters.self) {
        this.getBuyerProfile();
      }
      this.getItemsReport();
    });
  }

  getSellerProfile() {
    this.sellerProfile = this.resolverSerivce.userInitInfo.profile;
    if(this.sellerProfile.role.role_id == environment.role_types.admin) {
      this.sellerProfile.email = environment.email;
      this.sellerProfile.company = environment.title;
      this.sellerProfile.company_logo = environment.logoPrintSrc
    }
  }

  getBuyerProfile() {
    this.sharedCustomersService
      .getUserDetail(this.printFilters.buyer_id)
      .subscribe(
        (data) => {
          this.buyerProfile = data;
        },
        (error) => {
          this.snackbarService.showSnack(error.detail);
        }
      );
  }

  getItemsReport() {
    this.reportsService
      .getCascadeInvoiceItemsReport(this.printFilters)
      .subscribe(
        (data) => {
          this.itemList = data;
        },
        (error) => {
          this.snackbarService.showSnack(error.detail);
        }
      );
  }

  calcTotal() {
    let sum = 0;
    if (this.itemList) {
      sum = this.itemList.reduce(
        (sum, current) => sum + current.count * current.unit_price,
        0
      );
    }
    return sum;
  }
}
